import React, {useState, useEffect} from 'react'
import { Button, Badge, Row, Col, Alert, TabContent, TabPane, Nav, NavItem, NavLink, } from "reactstrap";
import * as firebase from "firebase";

import classnames from 'classnames';
import { Dropdown } from 'semantic-ui-react'
import {
  UserOutlined  } from "@ant-design/icons";
import { Card, Drawer, Form, Input, } from "antd";

import {Link} from "react-router-dom";

import { Firestore, Auth } from "../../config/firebase";
import pivot from "../../Logic/Pivot/pivot";
import UpvoteView from "../../components/UpvoteView";
import Collections from "../../Logic/collections/colections";
import CollectionsView from "../../components/Collection";
import UpvoteDisplay from "../../components/UpvotesDisplay";


export default function Allproducts(props) {
 
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }


  const [data, setData] = useState([]);
  const [message, setMessage] = useState('')

  const [visible, setVisible] = useState(false)

  const [Title, setTitle] = useState("");
  const [Highlight, setHighlight] = useState("");
  const [Deadline, setDeadline] = useState(new Date());
  const [Funds, setFunds] = useState("");
  const [Focus_Area, setFocus] = useState("");
  const [Type, setType] = useState([]);
  const [Apply, setwebapply] = useState("");
 
const [error, setError] = useState('')
const [dbValues, setUpdateC] = useState('')

  useEffect(() => {
    // const user = Auth.currentUser;
    // console.log(Auth.currentUser);
    function fetchUpdates() {
      Firestore.collection("allProducts")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push({ ...doc.data(), id: doc.id });
            // doc.data() is never undefined for query doc snapshots
          });

          setData(docs);
        });
    }

    fetchUpdates();
  }, []);


  const onFinish = values => {
    const data = {
      Title,  
      Highlight, 
      Deadline, 
      Funds,
      Focus_Area,  
      Type,
      Apply
    }
  console.log("Received values of form: ", data);

  if(!data) {
      
    setError("Fill Form Correctly")
    setMessage('')
  }

  else {
      Firestore.collection("allProduct").doc(dbValues.id)
      .update(data)
      .then(res => {
        setMessage("Product successfully added")
      })
      .catch(error => {
        throw error;
      });
  }
};


  const handleOnChange = (e, data) => {
    console.log(data.value);
    setType(data.value)
    console.log('Type', Type);
 }
  
  const showDrawer = (index) => {
    console.log(index)
    setVisible(true)
     
    Firestore.collection("allProducts")
       .doc(index)
       .get()
       .then(doc => {
         setUpdateC({...doc.data, id: doc.id })
 
         setTitle(doc.data().Title);
         setHighlight(doc.data().Highlight);
         setDeadline(doc.data().Deadline);
         setFunds(doc.data().Funds);
         setFocus(doc.data().Focus_Area);
         setType(doc.data().Type);
         setwebapply(doc.data().Apply);
       });
   };
 
 const onClose = () => {
     setVisible(false)
   };

   const options = [
    { key: 'venture fund', text: 'venture fund', value: 'venture fund'},
    { key: 'Accelerator', text: 'Accelerator', value: 'Accelerator'},
    { key: 'Crypto Fund', text: 'Crypto Fund', value: 'Crypto Fund'},
    { key: 'Grants', text: 'Grants', value: 'Grants'},
    { key: 'Bounty', text: 'Bounty', value: 'Bounty'},
    { key: 'Hackathon', text: 'Hackathon', value: 'Hackathon'},
 ]
 
  
  const DeleteAllproducts = (item) => {
  console.log(item)
  Firestore.collection("allProducts").doc(item).delete().then(function() {
     setMessage("Item delete successfully")
      Firestore.collection("allProducts")
      .get()
      .then(function(querySnapshot) {
        let docs = [];
        querySnapshot.forEach(function(doc) {
          docs.push({ ...doc.data(), id: doc.id });
          // doc.data() is never undefined for query doc snapshots
          setMessage("Item deleted successfully")
        
            setData(docs);
         
        });
      });

  }).catch(function(error) {
      console.error("Error removing document: ", error);
  });
}

    return(
    
        <>
         
          <Card className="mt-3">

              All Products
              <hr/>

              <div>
              <Nav pills>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
          >
            ALL
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
          >
            EVENTS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' })}
            onClick={() => { toggle('3'); }}
          >
            BOUNTY
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '4' })}
            onClick={() => { toggle('4'); }}
          >
            INVESTOR FOCUS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '5' })}
            onClick={() => { toggle('5'); }}
          >
            FUNDING ALERTS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '6' })}
            onClick={() => { toggle('6'); }}
          >
            DE-FI
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '7' })}
            onClick={() => { toggle('7'); }}
          >
            STARTUP
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '8' })}
            onClick={() => { toggle('8'); }}
          >
            LAUNCH
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '9' })}
            onClick={() => { toggle('9'); }}
          >
            EDUCATION
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '10' })}
            onClick={() => { toggle('10'); }}
          >
            INFOGRAPHICS
          </NavLink>
        </NavItem>

      </Nav>

      
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
        <Row>
                      <Col md={12} lg={12} sm={12} className="pb-3">
                        <Row>
        {data &&
                            data.map((item, index) => (
                              <>
                              
                                <Col
                                  md={12}
                                  lg={12}
                                  sm={12}
                                  className="p-3"
                                  key={index}
                                >
                                  <Card style={{ width: "100%" }}>
                                    <Row>
                                      <Col md={2} lg={2} sm={12}>
                                        <img src={item.Image} alt='itemin' style={{height:70, width:70}} />
                                      </Col>

                                      <Col md={8} lg={8} sm={12}>
                                        <Link >
                                          <h5
                                            className="mt-1"
                                            style={{ fontWeight: "bold" }}
                                          >
                                            {item.Title}
                                          </h5>
                                        </Link>
                                        <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                      </Col>

                                      <Col md={2} lg={2} sm={12}>
                                      <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>

                                    </Row>
                                  </Card>
                                </Col>
                              </>
                            ))}
                               </Row>
                      </Col>
                    </Row>
        </TabPane>

        <TabPane tabId="2">
            <Row>
                      <Col md={12} lg={12} sm={12} className="pb-3">
                        <Row>
                          {data &&
                            data.map((item, index) => (
                              <>
                                {item.Type.find(Investor => Investor == 'Event') ? (
                                  <Col
                                    md={12}
                                    lg={12}
                                    sm={12}
                                    className="p-3"
                                    key={index}
                                  >
                                    <Card style={{ width: "100%" }}>
                                      <Row>
                                        <Col md={2} lg={2} sm={12}></Col>

                                        <Col md={8} lg={8} sm={12}>
                                          <Link >
                                            <h5
                                              className="mt-1"
                                              style={{ fontWeight: "bold" }}
                                            >
                                              {item.Title}
                                            </h5>
                                          </Link>
                                          <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                          
                                            {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                            </Col>

                                        <Col md={2} lg={2} sm={12}>
                                          <UpvoteDisplay
                                            history={props.history}
                                            postID={item.id}
                                          />
                                          <CollectionsView
                                            id={item.id}
                                            history={props.history}
                                            action={() =>
                                              Collections.create(item.id)
                                            }
                                          />
                                        </Col>
                                      </Row>
                                    </Card>
                                  </Col>
                                ) : (
                                  ""
                                )}
                              </>
                            ))}
                        </Row>
                      </Col>
                    </Row>
                 
        </TabPane>

        <TabPane tabId="3">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Bounty') ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                       </div>

                                       {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
                 
        </TabPane>


        <TabPane tabId="4">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Investor Focus') ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
                 
        </TabPane>

        <TabPane tabId="5">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Funding')  ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
        </TabPane>

        <TabPane tabId="6">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'De-Fi')  ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
        </TabPane>

        <TabPane tabId="7">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Startup') ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>
                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
        </TabPane>

        <TabPane tabId="8">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Launch') ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
        </TabPane>

        <TabPane tabId="9">
        {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Education') ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
        </TabPane>

        <TabPane tabId="10">
        <Row>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {item.Type.find(Investor => Investor == 'Infograpics')  ? (
                              <Col
                                md={12}
                                lg={12}
                                sm={12}
                                className="p-3"
                                key={index}
                              >
                                <Card style={{ width: "100%" }}>
                                  <Row>
                                    <Col md={2} lg={2} sm={12}></Col>

                                    <Col md={8} lg={8} sm={12}>
                                      <Link >
                                        <h5
                                          className="mt-1"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {item.Title}
                                        </h5>
                                      </Link>

                                      <div style={{ height: "50px" }}>
                                          <b>{item.Highlight}</b>
                                          <div className="clearfix"></div>
                                        </div>

                                        {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                                    </Col>

                                    <Col md={2} lg={2} sm={12}>
                                    <Button
                                        className="btn-sm mt-2"
                                        outline
                                        color="danger"
                                        onClick={() => DeleteAllproducts(item.id)}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Row>
        </TabPane>
      </TabContent>
    </div>
 

             
             
             
            <Drawer
              title="Edit Product"
              placement="right"
              closable={false}
              onClose={onClose}
              visible={visible}
            >
               {message === '' ? '' : <Alert>{message}</Alert>}
           {error === '' ? '' : <Alert color={"danger"}>{error}</Alert>}
               <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
          >
            <Row>
              <Col md={12} lg={12} sm={12}>
                <label>Title</label>
                <Form.Item
                  name="Title"
                  rules={[
                    { required: true, message: "Please input your Title" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                   value={Title} placeholder={Title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Highlight</label>
                <Form.Item
                  name="Highlight"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Highlight line"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Highlight}
                    onChange={e => setHighlight(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Deadline</label>
                <Form.Item
                  name="Deadline"
                  rules={[
                    { required: true, message: "Please input your Deadline" }
                  ]}
                >
                
                  <Input type='date'
                  style={{width: '100%'}}
                    onChange={e => setDeadline(e.target.value)}
                  />
                   
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Funds</label>
                <Form.Item
                  name="Funds"
                  rules={[
                    { required: true, message: "Please input your Funds" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Funds}
                    onChange={e => setFunds(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Focus Area</label>
                <Form.Item
                  name="Focus Area"
                  rules={[
                    { required: true, message: "Please input your Focus Area" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Focus_Area}
                    onChange={e => setFocus(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={12} lg={12} sm={12}>
               <label>Type</label>   
              <Dropdown placeholder='Type' 
              onChange={handleOnChange} fluid 
              multiple selection options={options}
              defaultValue={dbValues.Type} />

              </Col>

              <Col md={12} lg={12} sm={12}>
                <label>Website Link</label>
                <Form.Item
                  name="Link"
                  rules={[
                    {
                      required: true,
                      message: "Please input your website Link"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    value={Apply}
                    onChange={e => setwebapply(e.target.value)}
                  />
                </Form.Item>
              </Col>


              <Col md={12} lg={12}>
                <hr />
              </Col>

              <Col md={12} lg={12} sm={12} className="text-right">
                <Button onClick={onFinish} htmlType="submit">Save</Button>
              </Col>
            </Row>
          </Form>
       
            </Drawer>
         
          </Card>
        </>
    
    
      
    )
}